import React from "react";
import logo from "./logo.svg";
import "./App.css";
import PlannerForm from "./PlannerForm";

function App() {
  return (
    <div className="App">
      <PlannerForm />
    </div>
  );
}

export default App;
